import axios from "axios";
import {GET_QUERY_OBJECT} from "../../admin/helpers/url_helper";
import {ssr_window} from "../helpers/ssr";

const SESSION_KEY_NAME = '__p_key'
const QUERY_KEY_NAME = 'inf_key'
export default {
  computed: {
    get_location() {
      return ssr_window.location?.search || ''
    }
  },
  mounted() {
    if (!this.get_location.includes(`${QUERY_KEY_NAME}=`)) return
    setTimeout(this.__sendPixelKey, 0)
  },
  methods: {
    async __sendPixelKey() {
      if (ssr_window.sessionStorage?.getItem(SESSION_KEY_NAME)) return
      let query_data = GET_QUERY_OBJECT(this.get_location);
      query_data['from_page'] = ssr_window.location.pathname + ssr_window.location.search
      axios.post('/api/check-pixel-key', query_data)
        .then(() => {
          ssr_window.sessionStorage.setItem(SESSION_KEY_NAME, query_data[QUERY_KEY_NAME])
        })
    }
  }
}
